<template>
  <b-form @submit="onSubmit" class="bg-form">
    <b-row>
      <b-col cols="12">
        <p class="bg-form__header bg-form__required">
          Opis artystyczny zespołu
        </p>
        <b-form-textarea
          id="textarea"
          v-model="extraFieldsJson.artistDescription"
          required
          placeholder="Opis artystyczny zespołu..."
          rows="6"
          max-rows="6"
          minlength="160"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6">
        <p class="bg-form__header bg-form__required">Twój email</p>
        <b-form-input
          id="input-1"
          v-model="form.email"
          type="email"
          required
          placeholder="_"
          autocomplete="off"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
        ></b-form-input>
        <p class="bg-form__header bg-form__required">Dodaj obrazek</p>
        <b-form-group label="Przeglądaj" label-for="file-1">
          <b-form-file
            id="file-1"
            ref="file-input-1"
            type="file"
            v-model="photos"
            required
            plain
            accept="image/jpeg, image/jpg"
            @change="checkImageFile"
          ></b-form-file>
          <div class="file-input-text">
            {{ photos === null ? "Nie wybrano pliku" : photos.name }}
          </div>
        </b-form-group>
        <p v-show="!errors.img.lenght > 0" class="bg-form__error">
          {{ errors.img }}
        </p>
        <p class="bg-form__header bg-form__required">Dodaj oświadczenie</p>
        <b-form-group label="Przeglądaj" label-for="file-2">
          <b-form-file
            id="file-2"
            ref="file-input-2"
            type="file"
            v-model="documents"
            required
            plain
            accept="image/jpeg, image/jpg, application/pdf"
            @change="checkDocumentFile"
          ></b-form-file>
          <div class="file-input-text">
            {{ documents === null ? "Nie wybrano pliku" : documents.name }}
          </div>
        </b-form-group>
        <p v-show="!errors.documents.lenght > 0" class="bg-form__error">
          {{ errors.documents }}
        </p>
      </b-col>
      <b-col lg="6">
        <p class="bg-form__header bg-form__required">Twój podpis</p>
        <b-form-input
          id="input-2"
          v-model="extraFieldsJson.signature"
          type="text"
          placeholder="_"
          required
          autocomplete="off"
        ></b-form-input>

        <!-- <p class="bg-form__header bg-form__required">Dodaj link</p>
        <b-form-input
          id="input-3"
          v-model="extraFieldsJson.link"
          type="url"
          required
          placeholder="_"
          @change="checkLink"
          ref="link-input"
          autocomplete="off"
        ></b-form-input>
        <p v-show="!errors.link.lenght > 0" class="bg-form__error">{{ errors.link }}</p>-->

        <!-- mp3  -->
        <p class="bg-form__header bg-form__required">Dodaj piosenkę</p>
        <b-form-group label="Przeglądaj" label-for="file-3">
          <b-form-file
            id="file-3"
            ref="file-input-3"
            type="file"
            v-model="song0"
            required
            plain
            accept=".mp3"
            @change="checkSongFile"
          ></b-form-file>
          <div class="file-input-text">
            {{ song0 === null ? "Nie wybrano pliku" : song0.name }}
          </div>
        </b-form-group>
        <p v-show="!errors.song.lenght > 0" class="bg-form__error">
          {{ errors.song }}
        </p>
        <!-- end mp3      -->

        <div class="chkbox-rules">
          <label
            for="checkbox-1"
            v-bind:class="{ active: rulesJson.isAcceptedGeneralRules }"
          ></label>
          <input
            id="checkbox-1"
            v-model="rulesJson.isAcceptedGeneralRules"
            name="checkbox-1"
            required
            type="checkbox"
          />

          <p class="chkbox-rules__text">
            Zgadzam się z
            <a
              href="https://static.prsa.pl/0b945381-ad55-4a4d-9ee2-a1052cdb1667.pdf"
              target="_blank"
              >regulaminem</a
            >
            i akceptuję jego postanowienia
          </p>
        </div>
        <div class="send-btn__wrapper">
          <b-button variant="outline-primary" type="submit" class="send-btn"
            >Wyślij</b-button
          >
          <div v-show="loader" class="send-btn__loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p v-show="!errors.send.lenght > 0" class="bg-form__error">
            {{ errors.send }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="statement-box">
          <a
            href="https://static.prsa.pl/f9c1a861-42d0-4eb6-9b6d-7614904e62fe.pdf"
            target="_blank"
            class="statement-link"
          >
            <span></span>Tu możesz pobrać plik oświadczenia
          </a>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import axios from "axios";
  // import "bootstrap/dist/css/bootstrap.css";
  // import "bootstrap-vue/dist/bootstrap-vue.css";

  export default {
    name: "FormView",
    data: function () {
      return {
        form: {
          formGroup: "69",
          firstName: "",
          lastName: "",
          nick: "",
          email: "",
          extraFieldsJson: "",
          title0: "",
          songWriters0: "",
          performer0: "",
        },
        photos: null,
        documents: null,
        song0: null,
        extraFieldsJson: {
          artistDescription: "",
          signature: "",
        },
        rulesJson: {
          isAcceptedGeneralRules: null,
        },
        rulesJson2: {
          IsAcceptedGeneralRules: "true",
        },
        errors: {
          img: "",
          documents: "",
          song: "",
          send: "",
        },
        loader: false,
      };
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();

        this.errors.link = "";
        this.extraFieldsJson.artistDescription =
          this.extraFieldsJson.artistDescription.replace(/"/g, "'");
        // this.form.rulesJson = JSON.stringify(this.rulesJson2);
        // console.log(this.form.rulesJson);
        this.form.extraFieldsJson = JSON.stringify(this.extraFieldsJson);
        this.form.firstName = this.extraFieldsJson.signature;
        this.form.lastName = this.extraFieldsJson.signature;
        this.form.nick = this.extraFieldsJson.signature;
        console.log(this.form);
        var submission = new FormData();
        for (var key in this.form) {
          var el = this.form[key];
          submission.append(key, el);
        }
        submission.append("rulesConsent", "true");
        submission.append("photos", this.photos);
        submission.append("documents", this.documents);
        submission.append("song0", this.song0);
        console.log(this.form);
        console.log(this.song0);
        console.log(submission);
        this.loader = true;
        this.errors.send = "";
        var self = this;
        axios({
          method: "POST",
          url: "//formularze.polskieradio.pl/saveform",
          data: submission,
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then(function (response) {
            if (response.status === 200) {
              console.log(response);
              self.$emit("formChangeView");
            } else {
              self.loader = false;
              self.errors.send = "Coś poszło nie tak, spróbuj ponownie później";
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loader = false;
            self.errors.send = "Coś poszło nie tak, spróbuj ponownie później";
          });
      },
      checkImageFile(e) {
        var self = this;
        var _URL = window.URL || window.webkitURL;
        var imageFile = e.target.files;
        if (imageFile[0]) {
          if (
            imageFile[0].type == "image/jpeg" ||
            imageFile[0].type == "image/jpg"
          ) {
            self.errors.img = "";
            var file, img;
            if ((file = imageFile[0])) {
              img = new Image();
              img.onload = function () {
                if (img.width < 1200) {
                  self.errors.img =
                    "Zdjęcie powinno mieć rozmiar minimum 1200x660 px.";
                  self.resetImageFile();
                } else if (img.height < 660) {
                  self.errors.img =
                    "Zdjęcie powinno mieć rozmiar minimum 1200x660 px.";
                  self.resetImageFile();
                } else {
                  self.errors.img = "";
                }
                // console.log('width' + img.width + ' ' + 'height' + img.height)
              };
              img.src = _URL.createObjectURL(file);
            }
          } else {
            self.errors.img = "Dozwolone są tylko pliki w formacie jpg.";
            self.resetImageFile();
          }
        }
      },
      resetImageFile() {
        this.$refs["file-input-1"].reset();
      },
      checkDocumentFile(e) {
        var documentFile = e.target.files;
        if (documentFile[0]) {
          if (
            documentFile[0].type == "image/jpeg" ||
            documentFile[0].type == "image/jpg" ||
            documentFile[0].type == "application/pdf"
          ) {
            this.errors.documents = "";
          } else {
            this.errors.documents =
              "Oświadczenie musi być w formacie pdf lub jpg!";
            this.resetDocumentFile();
          }
        }
      },
      resetDocumentFile() {
        this.$refs["file-input-2"].reset();
      },
      checkSongFile(e) {
        var songFile = e.target.files;
        if (songFile[0] && songFile[0].type == "audio/mpeg") {
          this.form.title0 = songFile[0].name;
        } else {
          this.resetSongFile();
        }
      },
      resetSongFile() {
        this.$refs["file-input-3"].reset();
      },
      // checkLink() {
      //   if (
      //     this.extraFieldsJson.link.indexOf("youtu.be") >= 0 ||
      //     this.extraFieldsJson.link.indexOf("youtube.com") >= 0
      //   ) {
      //     this.errors.link = "Link nie może być z YouTube";
      //   } else {
      //     this.errors.link = "";
      //   }
      // }
    },
  };
</script>
